/// <summary>
/// Store errors in a list.
/// To be used by multiple error generators to output them in the same location

import { CabinetGeneratorError } from "./CabinetGeneratorError";

/// </summary>
export class CabinetGeneratorErrorRegistry {
    public errors: CabinetGeneratorError[] = [];

    /// <summary>
    /// Add an error to the registry
    /// </summary>
    /// <param name="error"></param>
    public raiseError(error: CabinetGeneratorError): void {
        this.errors.push(error);
    }
}
